@if (items.length) {
    <nav aria-label="Breadcrumb" class="breadcrumbs">
        <ol class="breadcrumbs__list">
            @for (item of items; track item; let last = $last) {
                <li class="breadcrumbs__item">
                    @if (item.route && !last) {
                        <a [fragment]="item.fragment" [queryParams]="item.queryParams" [routerLink]="item.route">
                            {{ item.label }}
                        </a>
                    } @else {
                        <span [class.breadcrumbs__text--current]="last"
                              class="breadcrumbs__text">{{ item.label }}</span>
                    }
                    @if (!last) {
                        <span class="breadcrumbs__sep">/</span>
                    }
                </li>
            }
        </ol>
    </nav>
}
